import { css } from '@emotion/react';

import { useTranslation } from 'next-i18next';

import { Spacing, Typography } from 'chatie-design-system';

import Modal, { ModalButton, ModalProps } from '../common/Modal';

const dottedCSS = css`
  display: flex;
  margin-top: ${Spacing.small}px;
  align-items: center;
  align-self: stretch;
  ${Typography.body14};
  padding-right: ${Spacing.medium}px;
  padding-left: ${Spacing.medium}px;
`;

const SubscriptionErrorModal = ({ ...props }: ModalProps) => {
  const { t } = useTranslation();
  const { onClose } = props;

  return (
    <Modal {...props} title={t('문제가 생겼어요')}>
      <div css={dottedCSS}>
        <p className="multiline">
          {t(
            '저희 측 서버 오류로 인해\n회원님의 구독 상품이 성공적으로 구매되지 않았어요.\n결제하신 금액은 최소 3일 이후에\n자동으로 환불 될 예정이에요.\n불편을 드려 죄송합니다.'
          )}
        </p>
      </div>
      <ModalButton text={t('확인했어요')} onClick={() => onClose()} />
    </Modal>
  );
};

export default SubscriptionErrorModal;
